'use client';
import React from 'react';
import Icon from '@/components/ui/AppIcon';
import type { Filters } from './LessonLibraryClient';

interface ActiveFilterChipsProps {
  filters: Filters;
  onClear: (type: keyof Filters, value?: string | number) => void;
  onClearAll: () => void;
}

export default function ActiveFilterChips({ filters, onClear, onClearAll }: ActiveFilterChipsProps) {
  return (
    <div className="flex flex-wrap items-center gap-2 mb-5">
      <span className="text-xs text-stone-500 font-medium">Active filters:</span>
      {filters.grades.map((g) => (
        <Chip key={`chip-grade-${g}`} label={g} onRemove={() => onClear('grades', g)} />
      ))}
      {filters.topics.map((t) => (
        <Chip key={`chip-topic-${t}`} label={t} onRemove={() => onClear('topics', t)} />
      ))}
      {filters.sdgs.map((s) => (
        <Chip key={`chip-sdg-${s}`} label={`SDG ${s}`} onRemove={() => onClear('sdgs', s)} />
      ))}
      {filters.durations.map((d) => (
        <Chip key={`chip-dur-${d}`} label={d} onRemove={() => onClear('durations', d)} />
      ))}
      {filters.freeOnly && (
        <Chip label="Free Only" onRemove={() => onClear('freeOnly')} />
      )}
      <button
        onClick={onClearAll}
        className="text-xs text-primary-600 hover:text-primary-700 font-medium underline transition-colors"
      >
        Clear all
      </button>
    </div>
  );
}

function Chip({ label, onRemove }: { label: string; onRemove: () => void }) {
  return (
    <span className="inline-flex items-center gap-1.5 pl-3 pr-2 py-1 rounded-full bg-primary-50 text-primary-700 text-xs font-medium border border-primary-200">
      {label}
      <button
        onClick={onRemove}
        className="w-4 h-4 rounded-full bg-primary-200 hover:bg-primary-300 flex items-center justify-center transition-colors"
        aria-label={`Remove ${label} filter`}
      >
        <Icon name="XMarkIcon" size={10} />
      </button>
    </span>
  );
}